module.exports = __webpack_public_path__ + "static/media/html.2df01885.png";